import { render, staticRenderFns } from "./afterSales.vue?vue&type=template&id=3cc9b262"
import script from "./afterSales.vue?vue&type=script&lang=js"
export * from "./afterSales.vue?vue&type=script&lang=js"
import style0 from "./afterSales.vue?vue&type=style&index=0&id=3cc9b262&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports